<template>
  <div>
    <Header />
    <div class="middle1 flex-wrap" style="margin-top: 14px">
      <div>
        <MyInfo :num111="16" />
      </div>

      <div class="my_right flex-con">
        <div class="order_box">
          <div class="align-start cheng_head11">
            <div class="font-333-20-bold">推广链接</div>
          </div>
          <div style="padding-right: 32px">
            <div class="font-333-16-bold flex-wrap" style="margin-top: 22px">
              <div class="width102 align-end">佣金余额:</div>
              <div class="">{{ data.user_business_money || 0 }}</div>
            </div>
            <div class="font-333-16-bold flex-wrap" style="margin-top: 22px">
              <div class="width102 align-end">推广链接:</div>

              <div>{{ data.shareUrl || '' }}</div>
            </div>
            <div
              class="font-333-16-bold align-top"
              style="margin-top: 22px; margin-bottom: 22px"
            >
              <div class="width102">推广二维码:</div>
              <div class="">
                <el-image
                  v-if="data.user_invite_url"
                  style="width: 100px; height: 100px"
                  :src="data.user_invite_url"
                  fit="cover"
                ></el-image>

                <a
                  :href="data.user_invite_url"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="display: block; text-align: center"
                  >下载图片</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import MyInfo from '@/components/MyInfo.vue'
import right from '@/components/right.vue'
import {
  commitApply,
  showAuth,
  authStatus,
  uploadFile,
  showUserBaseForH5,
  businessAsk,
} from '../api'
export default {
  components: {
    Header,
    Footer,
    MyInfo,
    right,
  },
  data() {
    return {
      data: {},
    }
  },
  methods: {
    initData() {
      let params = {}
      showUserBaseForH5(params).then((data) => {
        if (data.status == 200) {
          this.data = data.msg
        }
      })
    },
  },
  mounted() {
    document.title = '爱优服'
    this.initData()
  },
}
</script>

<style scoped>
.input1::file-selector-button {
  width: 101px;
  height: 29px;
  background: #ffffff;
  border: 1px solid #d8d8d8;
  /* border-radius: 5px; */
  font-size: 16px;
  font-weight: 400;
  color: #999;
  padding-bottom: 3px;
  margin-right: 18px;
  cursor: pointer;
}
.input1 {
  font-size: 16px;
  font-weight: 400;
  color: #6eaaf9;
}
.my_order {
  background: #ffffff;
  border-radius: 4px;
  padding: 20px 26px;
  font-size: 14px;
  margin-bottom: 10px;
  text-align: center;
}
.order_box {
  background: #ffffff;
  box-sizing: border-box;
  text-align: left;
  border: 1px solid #eeeeee;
}
input[type='text'] {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  height: 32px;
  /* width: 250px; */
  padding: 0 12px;
  color: #333333;
  font-size: 16px;
  outline: none;
}
input[type='text']::-webkit-input-placeholder {
  color: #999;
}
input[type='text']:active {
  box-sizing: border-box;
  border: 1px solid #d8d8d8;
}

.btn {
  font-size: 20px;
  color: #ffffff;
  margin: 30px auto 35px;
  width: 256px;
  height: 46px;
  background: #fa9c22;
  border-radius: 4px;
}
.width102 {
  min-width: 102px;
  text-align: right;
  margin-right: 26px;
}
::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

::v-deep .el-input--mini .el-input__inner {
  border-radius: 0px;
  border: 1px solid #d8d8d8;
  height: 32px;
  font-size: 16px;
  /* color: #999; */
}

.el-select-dropdown__item {
  font-size: 16px;
}
.el-select-dropdown__item.selected {
  color: #333;
}
</style>
